import { render } from "./Contratos.vue?vue&type=template&id=d1cab95a"
import script from "./Contratos.vue?vue&type=script&lang=js"
export * from "./Contratos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__